<template>
    <div class="consulAddDialog">
        <!-- 办理表单 -->
        <el-form
            ref="form"
            :model="form"
            label-width="130px"
            v-if="moduleShow3"
        >
            <!-- <el-form-item label="议题名称">
        <el-input v-model="consultName" disabled></el-input>
      </el-form-item> -->
            <el-form-item label="议题层级">
                <el-input
                    v-model="bargainingLevel"
                    disabled
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="议题内容">
                <el-input
                    v-model="content"
                    type="textarea"
                    disabled
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="协商内容">
                <el-input
                    v-model="negotiationContent"
                    type="textarea"
                    disabled
                    style="width: 90.5%"
                ></el-input>
            </el-form-item>
            <el-form-item label="邀请协商人员">
                <el-button
                    v-if="readonlybls !== true"
                    size="mini"
                    type="success"
                    @click="addPersonInfo"
                    >添加</el-button
                >
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 80%"
                >
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column
                        align="center"
                        label="序号"
                        type="index"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="姓名"
                        prop="name"
                        width="120"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="sex"
                        label="性别"
                        width="60"
                    >
                        <template scope="scope">
                            <span v-if="scope.row.sex == 0">男</span>
                            <span v-if="scope.row.sex == 1">女</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        label="手机号"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="parentPersonTypeName"
                        label="类别"
                        show-overflow-tooltip
                    ></el-table-column>
                    <!-- <el-table-column align="center" label="操作" width="120">
            <template scope="scope">
              <button :disabled='readonlybls'  class="iconfont icon-icon7 tabBtn" style='color:#dd3020;' @click="deleteBtn(scope.$index)"></button>
            </template>
          </el-table-column> -->
                </el-table>
            </el-form-item>
            <el-form-item label="协商时间">
                <el-date-picker
                    :disabled="readonlybls"
                    v-model="form.handleTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期时间"
                    style="width: 90.5%"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="发送方式">
                <el-radio
                    :disabled="readonlybls"
                    v-model="form.sendMethod"
                    label="0"
                    >短信</el-radio
                >
                <el-radio
                    :disabled="readonlybls"
                    v-model="form.sendMethod"
                    label="1"
                    >APP</el-radio
                >
            </el-form-item>
            <el-form-item label="发送内容">
                <el-input
                    :disabled="readonlybls"
                    size="mini"
                    style="width: 90.5%"
                    v-model="form.sendContent"
                    placeholder="请输入"
                    type="textarea"
                ></el-input>
            </el-form-item>
            <el-form-item label="协商地点" style="margin-top: 20px">
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 15px;
                        width: 90.5%;
                    "
                >
                    <el-select
                        :disabled="readonlybls"
                        class="div_inout_width"
                        v-model="form.province"
                        style="margin-right: 20px"
                        placeholder="请选择"
                    >
                        <el-option label="天长市" value="1"></el-option>
                    </el-select>
                    <el-select
                        :disabled="readonlybls"
                        class="div_inout_width"
                        style="margin-right: 20px"
                        @change="getAddressByParentId"
                        v-model="form.city"
                        placeholder="请选择"
                    >
                        <el-option label="浔河社区" value="2"></el-option>
                        <el-option label="石街社区" value="20"></el-option>
                    </el-select>
                    <el-select
                        :disabled="readonlybls"
                        class="div_inout_width"
                        v-model="areaId"
                        placeholder="--选择网格--"
                    >
                        <el-option
                            v-for="item in gridCode"
                            :key="item.id"
                            :label="item.orgName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div>
                <div style="display: flex; margin-bottom: 15px">
                    <el-input
                        :disabled="readonlybls"
                        style="width: 90.5%"
                        class="input70"
                        v-model="form.handlePlace"
                        @blur="transLocation"
                    ></el-input>
                </div>
                <div style="display: flex; margin-bottom: 15px">
                    <div
                        id="container"
                        class="input70"
                        style="height: 200px; margin-bottom: 50px; width: 90.5%"
                    ></div>
                </div>
            </el-form-item>
            <!-- <el-form-item label="协商地点">
        <el-input :disabled='readonlybls' v-model="form.handlePlace" style='width:90.5%'></el-input>
      </el-form-item>  -->
            <!-- 短信发送列表  -->
            <el-form-item
                class="tablewh"
                style="margin-top: 50px"
                label-width="0px"
            >
                <el-table
                    :data="rowDataTable"
                    :header-cell-style="{ background: '#f8fafa' }"
                    border
                    align="center"
                    current-row-key
                    highlight-current-row
                >
                    <el-table-column
                        align="center"
                        type="index"
                        width="80"
                        label="序号"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="orgName"
                        label="议题编号"
                    >
                        <template slot-scope="scope">
                            <span>{{
                                scope.row.orgName == null
                                    ? "治东社区"
                                    : scope.row.orgName
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="counts"
                        label="镇/街道"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="counts"
                        label="村/社区"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="counts"
                        label="已发送"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="yescounts"
                        label="已接收"
                    >
                        <template slot-scope="scope">
                            <span @click="getReceived" style="color: blue">{{
                                scope.row.yescounts
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="nocounts"
                        label="未接收"
                    >
                        <template slot-scope="scope">
                            <span @click="getNotreceived" style="color: red">{{
                                scope.row.nocounts
                            }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <!-- 查看已接收弹框 -->
            <el-dialog
                :title="fstdialogTitle"
                :visible.sync="ReceivedDisable"
                width="1000px"
                :before-close="clearReceivedlook"
            >
                <!-- 表格盒子 -->
                <div class="table_card">
                    <el-table
                        :data="yesCountsList"
                        :header-cell-style="{ background: '#f8fafa' }"
                        border
                        align="center"
                        current-row-key
                        highlight-current-row
                    >
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            type="index"
                            width="80"
                            label="序号"
                        ></el-table-column>
                        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="personCounts" label="姓名"></el-table-column>   -->
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="linkPhone"
                            label="手机号"
                        ></el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="createDate"
                            label="发送时间"
                        ></el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="status"
                            label="发送状态"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 0">失败</span>
                                <span v-if="scope.row.status == 1">成功</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="content"
                            label="发送内容"
                        ></el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="returnContent"
                            label="回复内容"
                        ></el-table-column>
                    </el-table>
                    <!-- 分页功能 -->
                    <el-pagination
                        layout="total, prev, pager, next, jumper"
                        :current-page="pageConfig.pageNo"
                        :page-size="pageConfig.pageSize"
                        :total="pageConfig.total"
                        @current-change="receivedCurrentChange"
                    ></el-pagination>
                </div>
            </el-dialog>
            <!-- 查看未接收弹框 -->
            <el-dialog
                :title="fstdialogTitle"
                :visible.sync="NotreceivedtDisable"
                width="1000px"
                :before-close="clearNotreceivedlook"
            >
                <!-- 表格盒子 -->
                <div class="table_card">
                    <el-table
                        :data="noCountsList"
                        :header-cell-style="{ background: '#f8fafa' }"
                        border
                        align="center"
                        current-row-key
                        highlight-current-row
                    >
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            type="index"
                            width="80"
                            label="序号"
                        ></el-table-column>
                        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="personCounts" label="姓名"></el-table-column>   -->
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="linkPhone"
                            label="手机号"
                        ></el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="createDate"
                            label="发送时间"
                        ></el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="status"
                            label="发送状态"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 0">失败</span>
                                <span v-if="scope.row.status == 1">成功</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            prop="content"
                            label="发送内容"
                        ></el-table-column>
                    </el-table>
                    <!-- 分页功能 -->
                    <el-pagination
                        layout="total, prev, pager, next, jumper"
                        :current-page="pageConfig.pageNo"
                        :page-size="pageConfig.pageSize"
                        :total="pageConfig.total"
                        @current-change="notreceivedCurrentChange"
                    ></el-pagination>
                </div>
            </el-dialog>
            <el-form-item>
                <div class="queRenBtn">
                    <el-button
                        type="primary"
                        v-if="readonlybls !== true"
                        @click="onSave"
                        >确定</el-button
                    >
                    <el-button v-if="readonlybls !== true" @click="quXiao"
                        >取消</el-button
                    >
                </div>
            </el-form-item>
        </el-form>

        <!-- 选择人员列表弹框 -->
        <el-dialog
            append-to-body=""
            title="添加人员类别"
            :visible.sync="checkpeopType"
        >
            <el-form :inline="true" :model="menbersearchlist" size="mini">
                <el-form-item label="活动区域">
                    <el-select
                        v-model="menbersearchlist.parentPersonTypeId"
                        placeholder="--请选择上级类别--"
                    >
                        <el-option
                            v-for="item in searchGroups"
                            :key="item.id"
                            :label="item.consultName"
                            :value="item.id"
                            :disabled="item.checked"
                        ></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onsearchSubmit"
                        >查询</el-button
                    >
                </el-form-item>
            </el-form>
            <el-table
                :data="menberList"
                border
                style="width: 100%"
                @selection-change="handleSelectionChange"
                ref="multipleTable"
                :row-key="getRowKey"
            >
                <el-table-column
                    type="selection"
                    :reserve-selection="true"
                    width="55"
                ></el-table-column>
                <el-table-column
                    type="index"
                    label="序号"
                    width="55"
                ></el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名"
                    width="100"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="sex"
                    label="性别"
                    width="55"
                    :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        <span v-if="scope.row.sex == 0">男</span>
                        <span v-if="scope.row.sex == 1">女</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="手机号"
                    width="130"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="parentPersonTypeName"
                    label="类别"
                    :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
            <!-- 参与协商人员列表分页功能 -->
            <el-pagination
                layout="total, prev, pager, next, jumper"
                :current-page="pageConfig2.pageNo"
                :page-size="pageConfig2.pageSize"
                :total="pageConfig2.total"
                @current-change="handleCurrentChange"
            ></el-pagination>
            <div class="menberBtn">
                <el-button type="primary" size="small" @click="createData"
                    >保存</el-button
                >
            </div>
        </el-dialog>
        <!-- <el-dialog append-to-body=''  title='添加人员类别'  :visible.sync='checkpeopType'>
      <peopleTypeDialog @func="choosePeopleTypeFunc"  :isshow="checkpeopType" :fatherdata="addformTypeArr"></peopleTypeDialog>
    </el-dialog> -->
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import peopleTypeDialog from "./peopleTypeDialog.vue"
import { tabdata } from "@/mixins/tabledataMix.js"
export default {
    props: ["ytid", "show", "readonlybl"],
    components: { peopleTypeDialog },
    mixins: [tabdata],
    data() {
        return {
            gridCode: [],
            searchGroups: [],
            areaId: "",
            id: this.ytid,
            readonlybls: this.readonlybl,
            ReceivedDisable: false, //已接收弹框控制
            NotreceivedtDisable: false, //未接收弹框控制
            yesCountsList: [], //已接收列表
            fstdialogTitle: "查看",
            noCountsList: [], //已接收列表
            rowDataTable: [],
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            pageConfig2: {
                pageSize: 5,
                total: 0,
                pageNo: 1,
            },
            ConsultOrgOption: [],
            ConsultPersonOptions: [],
            dialogImageUrl: "",
            dialogVisible: false,
            id: this.ytid,
            value1: "",
            radio: "1",
            form: {
                handleTime: "",
                handlePlace: "",
                host: "",
                record: "",
                noteTaker: "",
                approvalStatus: "",
                photo: "",
                sendContent: "",
            },
            tableData: [],
            multipleSelection: [],
            consultName: "",
            content: "",
            bargainingLevel: "",
            persons: [],
            dialogImageUrl: "",
            dialogVisible: false,
            disabled: false,
            imageUrl: "",
            jiaobanform: {},
            moduleShow1: false,
            moduleShow2: false,
            moduleShow3: true,
            addform: {},
            negotiationContent: "",
            orgName: "",
            streetName: "",
            xsytList: [
                {
                    value: "1",
                    label: "党小组、村(居)民组会议",
                },
                {
                    value: "2",
                    label: "群众通过电话或口头等方式",
                },
                {
                    value: "3",
                    label: "群众通过微信、QQ等方式提出",
                },
                {
                    value: "4",
                    label: "党员议事日",
                },
                {
                    value: "5",
                    label: "意见箱",
                },
                {
                    value: "6",
                    label: "包组干部收集到群众的需求",
                },
                {
                    value: "7",
                    label: "落实上级党委政府工作安排",
                },
                {
                    value: "8",
                    label: "其他",
                },
            ],
            xszjList: [
                {
                    value: "1",
                    label:
                        '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项',
                },
                {
                    value: "2",
                    label: '涉及1个村以上"两委"成员包组范围内1村(居)民组事项',
                },
                {
                    value: "3",
                    label: "涉及与本镇内1个村以上范围事项",
                },
                {
                    value: "4",
                    label: "涉及本镇以外其他镇的协商事项",
                },
            ],
            sureList: [
                {
                    value: "0",
                    label: '村"两委"会',
                },
                {
                    value: "1",
                    label: "扩大会",
                },
                {
                    value: "2",
                    label: "党员议事会",
                },
            ],
            tableData: [],
            checkpeopType: false,
            addformTypeArr: [],
            menberList: [],
            menbersearchlist: {},
        }
    },
    computed: {
        // 动态给步骤加样式
        stepClassObj(val) {
            return (val) => {
                return {
                    stepSuc: this.stepSuc.includes(val),
                    stepErr: !this.stepSuc.includes(val),
                }
            }
        },
    },
    methods: {
        // 选择关联产品：打勾或取消
        handleSelectionChange(selecteds) {
            console.log("selecteds", selecteds)
            this.multipleSelection = selecteds
        },
        //封装数据
        createData() {
            console.log(this.multipleSelection)
            this.tableData = this.multipleSelection
            this.checkpeopType = false
        },
        //问题二、数据回显问题
        getRowKey(row) {
            return row.id
        },
        onsearchSubmit() {
            this.pageConfig2.pageNo = 1
        },
        getMenberList() {
            post("/admin/consulType/info/findConsultPersonList", {
                ...this.searchlist,
                pageNo: this.pageConfig2.pageNo,
                pageSize: this.pageConfig2.pageSize,
                approvalStatus: 1,
                status: 0,
                menuType: "",
            }).then((res) => {
                if (res.code == 200) {
                    this.pageConfig2.total = res.content.count
                    this.menberList = res.content.list
                    let newdata = []
                    for (const key in this.multipleSelection) {
                        if (this.multipleSelection.hasOwnProperty(key)) {
                            newdata = newdata.concat(
                                this.multipleSelection[key]
                            )
                        }
                    }
                }
            })
        },
        //已接收信息弹窗分页
        receivedCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getReceived()
        },
        //未接收信息弹窗分页
        notreceivedCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getNotreceived()
        },
        //人员列表分页
        handleCurrentChange(val) {
            this.pageConfig2.pageNo = val
            this.getMenberList()
        },
        // 查看- 已接收未发送弹出框重置
        clearReceivedlook() {
            this.ReceivedDisable = false
        },
        // 查看- 未接收弹出框重置
        clearNotreceivedlook() {
            this.NotreceivedtDisable = false
        },
        onSave() {
            this.persons = []
            this.tableData.forEach((item) => {
                var person = {}
                this.person = { personId: item.id + "", type: "0" }
                this.persons.push(this.person)
            })
            this.$set(this.form, "area", this.areaId)
            console.log("area", this.form.area)
            post("/admin/consultHandle/info/insertConsultHandle", {
                ...this.form,
                consultId: this.ytid,
                persons: this.persons,
            }).then((res) => {
                console.log(res)
                if (res.code == 200) {
                    this.$message({
                        message: "协商议题办理成功",
                        type: "success",
                    })
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
                this.$emit("close")
            })
        },
        quXiao() {
            this.$emit("close")
            this.persons = []
            this.tableData = []
            this.multipleSelection = []
        },
        // 重置
        getData() {
            console.log(111222333)
            this.form = {}
            this.consultName = ""
            this.content = ""
            this.bargainingLevel = ""
            this.persons = []
            this.tableData = []
            this.multipleSelection = []
            this.areaId = ""
        },
        getfindConsultHandle() {
            this.form = {}
            post("admin/consultHandle/info/findConsultHandleByConsultId", {
                consultId: this.ytid,
            }).then((res) => {
                if (res.content) {
                    console.log(res.content)
                    this.form = res.content
                    this.areaId = res.content.areaName
                }
            })
        },
        getListConsultOrg() {
            post("admin/consulOrg/info/listConsultOrg", {
                pageNo: 1,
                pageSize: 100,
                status: 0,
            }).then((res) => {
                this.ConsultOrgOption = res.content.list
            })
        },
        getsearchGroupOrg() {
            post("admin/consultPersonType/info/findConsultPersonTypeList", {
                pageNo: 1,
                pageSize: 9999,
                status: "0",
            }).then((res) => {
                this.searchGroups = res.content.list
            })
        },
        getConsultList() {
            console.log("111---" + this.ytid, this.readonlybl)
            post("/admin/consult/info/findConsultById", {
                id: this.ytid,
            }).then((res) => {
                // console.log(111,res.content);
                this.consultName = res.content.consultName
                this.content = res.content.content
                if (res.content.bargainingLevel == "1") {
                    this.bargainingLevel =
                        '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项'
                } else if (res.content.bargainingLevel == "2") {
                    this.bargainingLevel =
                        '涉及1个村以上"两委"成员包组范围内1村(居)民组事项'
                } else if (res.content.bargainingLevel == "3") {
                    this.bargainingLevel = "涉及与本镇内1个村以上范围事项"
                } else if (res.content.bargainingLevel == "4") {
                    this.bargainingLevel = "涉及本镇以外其他镇的协商事项"
                }
                this.persons = []
                res.content.persons.filter((item) => {
                    if (item.type == "0") {
                        this.persons.push(item)
                    }
                })
                this.negotiationContent = res.content.negotiationContent
                this.tableData = this.persons
            })
        },

        addPersonInfo() {
            this.tableData = []
            this.checkpeopType = true
            this.getMenberList()
        },
        // 选择人员类别返回选中成员
        choosePeopleTypeFunc(val) {
            this.tableData = []
            this.addformTypeArr = []
            this.checkpeopType = false
            this.addformTypeArr.push(val)
            this.tableData = this.addformTypeArr[0].persionArr
        },
        // 获取地址下拉
        getAddressByParentId(addId) {
            console.log(addId)
            this.gridCode = []
            this.form.areaId = ""
            post("/admin/org/info/findOrgGrid", {
                parentId: addId,
            }).then((res) => {
                console.log(res.content)
                this.gridCode = res.content.list
            })
        },
        //根据输入地址转换经纬度并标记
        transLocation() {
            var searchKey = this.form.handlePlace
            var map = new AMap.Map("container", {
                resizeEnable: true,
                zoom: 18,
            })
            var that = this
            AMap.plugin("AMap.Geocoder", function () {
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all",
                })
                var marker = new AMap.Marker()
                geocoder.getLocation(searchKey, function (status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        var lnglat = result.geocodes[0].location
                        that.form.longitude = String(lnglat.lng)
                        that.form.latitude = String(lnglat.lat)
                        console.log("that.form=>", that.form)
                        marker.setPosition(lnglat)
                        map.add(marker)
                        map.setFitView(marker)
                    } else {
                        that.$message({
                            message: "获取坐标失败，请手动获取",
                            type: "error",
                        })
                        that.mapInit("container")
                    }
                })
                map.on("click", function (e) {
                    that.form.longitude = String(e.lnglat.getLng())
                    that.form.latitude = String(e.lnglat.getLat())
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            console.log(status)
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress
                                that.$set(that.form, "handlePlace", address)
                            } else {
                                log.error("根据经纬度查询地址失败")
                            }
                        }
                    )
                })
            })
        },
        //初始化地图插件的方法
        mapInit(containerId) {
            console.log("containerId", containerId)
            var map = new AMap.Map(containerId, {
                resizeEnable: true,
                zoom: 18,
                zooms: [3, 20],
                expandZoomRange: true,
                center: [119.013268, 32.6739],
            })
            console.log(map)
            if (this.form.longitude && this.form.latitude) {
                var marker = new AMap.Marker({
                    position: [
                        Number(this.form.longitude),
                        Number(this.form.latitude),
                    ],
                    map: map,
                })
                map.setFitView(marker)
            } else {
                AMap.plugin("AMap.Geolocation", function () {
                    //异步定位当前
                    var geolocation = new AMap.Geolocation()
                    map.addControl(geolocation)
                })
            } //定义地图坐标点击事件
            var that = this
            var geocoder = new AMap.Geocoder({
                city: "010", //城市设为北京，默认：“全国”
                radius: 1000, //范围，默认：500
            })
            map.on("click", function (e) {
                that.form.longitude = String(e.lnglat.getLng())
                that.form.latitude = String(e.lnglat.getLat())
                geocoder.getAddress(
                    e.lnglat.getLng() + "," + e.lnglat.getLat(),
                    function (status, result) {
                        console.log(status)
                        if (status === "complete" && result.regeocode) {
                            var address = result.regeocode.formattedAddress
                            that.$set(that.form, "handlePlace", address)
                        } else {
                            log.error("根据经纬度查询地址失败")
                        }
                    }
                )
            })
        },
        deleteBtn(index) {
            this.tableData.splice(index, 1)
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.getListConsultOrg()
            this.getConsultList()
            this.getfindConsultHandle()
            this.getsearchGroupOrg()
            this.getMenberList()
            setTimeout(() => {
                this.mapInit("container")
            }, 500)
        })
        // console.log('form',this.form)
    },
}
</script>

<style lang="less" scoped>
.consulAddDialog {
    .el-form-item {
        margin-bottom: 10px;
        .el-form-item__error {
            top: 85%;
        }
    }
}
.queRenBtn {
    margin-top: 30px;
    margin-left: -130px;
    display: flex;
    justify-content: center;
}
.queRenBtn {
    .qubtn {
        cursor: not-allowed;
        background-color: #ccc;
        color: #fff;
    }
    .qubtn :hover {
        cursor: not-allowed;
        background-color: #ccc;
        color: #fff;
    }
    .qubtn_span {
        color: #409eff;
        margin-top: 10px;
    }
}
.tablewh {
    width: 85%;
    margin-top: 15px;
    margin: 20px auto;
}
.div_inout_width {
    width: 30%;
}
.menberBtn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>